'use client';

import {
    FacebookAuthProvider,
    GoogleAuthProvider,
    getRedirectResult,
    signInWithCredential,
    signInWithRedirect,
    type UserCredential,
} from 'firebase/auth';

import { getFirebaseAuth } from './config';

function getAuthOrThrow() {
    const a = getFirebaseAuth();
    if (!a) {
        throw new Error('Firebase is not configured. Set NEXT_PUBLIC_FIREBASE_* env variables.');
    }
    return a;
}

/** 使用 Facebook 用户 access_token 登录 Firebase（不经过 redirect / __/auth/handler） */
export async function signInWithFacebookAccessToken(accessToken: string): Promise<UserCredential> {
    const auth = getAuthOrThrow();
    const credential = FacebookAuthProvider.credential(accessToken);
    return signInWithCredential(auth, credential);
}

export async function signInWithGoogle(): Promise<void> {
    const auth = getAuthOrThrow();
    await signInWithRedirect(auth, new GoogleAuthProvider());
}

let redirectResultPromise: Promise<UserCredential | null> | null = null;

export function getFirebaseRedirectResult(): Promise<UserCredential | null> {
    if (!redirectResultPromise) {
        const auth = getFirebaseAuth();
        redirectResultPromise = auth ? getRedirectResult(auth) : Promise.resolve(null);
    }
    return redirectResultPromise;
}

/** 一次 redirect 流程结束后重置，便于下次再发起 OAuth redirect */
export function resetFirebaseRedirectResultCache(): void {
    redirectResultPromise = null;
}
